import { z } from "zod";

export const IMPACT_VERDICTS = ["isolated", "possibly_wider", "confirmed_wider", "unable_to_verify"] as const;
export type ImpactVerdict = (typeof IMPACT_VERDICTS)[number];

export const IMPACT_LABELS: Record<ImpactVerdict, string> = {
  isolated: "Isolated",
  possibly_wider: "Possibly wider",
  confirmed_wider: "Confirmed wider",
  unable_to_verify: "Unable to verify scope",
};

// Part of the triage answer, for a Bug that needs a ticket. Triage returns null for anything else.
export const impactSchema = z.object({
  verdict: z.enum(IMPACT_VERDICTS),
  // Only from a query or Rollbar count the run made; null when nothing was counted.
  affectedCompanies: z.number().nullable(),
  summary: z.string(),
  // The faulty logic, in 2-3 sentences, for a possibly or confirmed wider bug.
  faultyLogic: z.string().nullable(),
});
export type ImpactResult = z.infer<typeof impactSchema>;
